import React from 'react'
import { Link } from "react-router-dom"
import { CATEGORY_RIAN , CATEGORY_ONLINE } from '../../../constant'
import css from './Announce.module.scss'
import {formatDate, getTime} from "../../../utils"
import {TourContext} from "../../../context";

function Announce({ dataTarget, data }){
	const categories = data.categories || []
	const list_ids = categories.map(e => e.list_id)
	const { closeTour } = React.useContext(TourContext)

	return (
		<div className={css.announce} data-target={dataTarget + '-event'} onClick={closeTour}>
			<Link to={'/event/' + data.article_id} className={css.title}>{data.article_title}</Link>
			<div className={css.footer}>
				<span className={css.date}>
					{getTime(data.occurs_from, data.occurs_till)
						? <span className={css.time}>{getTime(data.occurs_from, data.occurs_till)}</span>
						: null
					}
					{formatDate(data.occurs_from, data.occurs_till)}
				</span>
				{list_ids.includes(CATEGORY_ONLINE) && <span className={css.tag}>онлайн</span>}
				{list_ids.includes(CATEGORY_RIAN) && <span className={css.tag + ' ' +css.blue}>мероприятие ММПЦ</span>}
			</div>
		</div>
	)
}

export default Announce